import * as React from "react";
import { connect } from "react-redux";
import NavigationHeader from "./NavigationHeader";
import NavigationBody from "./NavigationBody";
import SubModal from "theme/SubModal";
import toggleNavigation from "theme/dom/toggleNavigation";
import { Redirect } from "react-router-dom";
import { logout } from "actions/auth";
import { checkAuthSession } from "theme/utils";

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/navigation`);

const $STP = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/product`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      logoutModal: false,
      sessionExpiredModal: false,
      logoutRedirect: false,
    };

    this.logout = this.logout.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  async componentDidMount() {
    const IS_CHECK_AUTH_BRAND = $A.BRAND === "Koton" || $A.BRAND === "TFS";
    if (IS_CHECK_AUTH_BRAND) {
      const isAuthenticated = checkAuthSession();
      const localCurrentStaff = localStorage.getItem("localCurrentStaff");
      const localCurrentStaffControl =
        !!localCurrentStaff &&
        localCurrentStaff !== "null" &&
        localCurrentStaff !== "undefined";
      const { pathname } = window.location;

      if (localCurrentStaffControl && !isAuthenticated) {
        const { dispatch } = this.props;
        await dispatch(logout());
        this.setState({
          sessionExpiredModal:
            pathname !== "/store-selection" && pathname !== "/",
          logoutModal: false,
          logoutRedirect: false,
        });
      }
    }
  }

  async logout() {
    const { dispatch } = this.props;
    await dispatch(logout());
    await toggleNavigation();
    this.setState({
      logoutModal: true,
    });
    setTimeout(() => {
      this.setState({ logoutRedirect: true, logoutModal: true });
    }, 2500);
  }

  openModal(modalName) {
    this.setState({ modals: { [modalName]: true } });
  }

  closeModal() {
    this.setState({
      modals: {},
    });
    return <Redirect to="/store-selection" />;
  }

  renderSuccessLogoutMessage(render) {
    const { logoutModal } = this.state;
    return (
      render && (
        <SubModal
          classes="text-center inner-centered modal-column"
          onClose={() => this.setState({ logoutRedirect: true })}
          buttonText={$STP.OKAY}
          style={{ maxWidth: "400px", paddingBottom: "30px" }}
        >
          <p
            style={{ color: "#000", paddingTop: "30px", paddingBottom: "30px" }}
          >
            {logoutModal ? $ST.LOGOUT_SUCCESS : $ST.SESSION_EXPIRED}
          </p>
        </SubModal>
      )
    );
  }

  render() {
    const {
      dispatch,
      menuItems,
      pending,
      currentStaff,
      permissions = [],
      liveCommerce,
    } = this.props;
    if (this.state.logoutRedirect === true) {
      return <Redirect to="/store-selection" />;
    }

    const IS_CHECK_AUTH_BRAND = $A.BRAND === "Koton" || $A.BRAND === "TFS";

    return (
      <div>
        {this.renderSuccessLogoutMessage(
          this.state.logoutModal ||
            (IS_CHECK_AUTH_BRAND && this.state.sessionExpiredModal)
        )}
        <nav id="js-nav" className={this.props.classes}>
          <div
            onClick={() => toggleNavigation()}
            className="header-scene"
            id="js-header-sceen"
          />
          <NavigationHeader dispatch={dispatch} currentStaff={currentStaff} />
          <NavigationBody
            dispatch={dispatch}
            menuItems={menuItems}
            pending={pending}
            currentStaff={currentStaff}
            permissions={permissions}
            liveCommerce={liveCommerce}
            logout={this.logout}
          />
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuItems: state.navigation.menuItems,
    pending: state.navigation.pending,
    currentStaff: state.staffs.currentStaff,
    permissions: state.permissions.permissions,
    liveCommerce: state.webUrl.liveCommerce,
  };
};

export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/partials/Navigation.js